var ProductRenderer = (function() {

    function formatMoney(cents) {
        if (typeof cents !== 'number') return '';
        const value = (cents / 100).toFixed(2);
        return '$ ' + value.replace(/\.00$/, '');
    }

    function renderPrice(product) {
        let priceHtml = `<span class="plp-card-price-text">${formatMoney(product.price)}</span>`;
        if (product.compare_at_price && product.compare_at_price > product.price) {
            priceHtml += ` <span class="plp-card-compare-price plp-card-price-text" style="text-decoration: line-through; margin-left: 5px;">${formatMoney(product.compare_at_price)}</span>`;
        }
        return priceHtml;
    }

    function renderDimensionsTable(tags) {
        if (!tags || !Array.isArray(tags)) return '';

        let rows = '';
        tags.forEach(function(tag) {
             if(tag.includes(':')) {
                if(tag.includes('length') || tag.includes('width') || tag.includes('thickness') || tag.includes('radius') || tag.includes('diameter')) {
                    if(!tag.includes('N/A')) {
                        const parts = tag.split(':');
                        const label = parts[0].replace(/_/g, ' ');
                        const value = parts[1];

                        rows += `
                        <tr class="plp-card-table-row">
                          <td class="plp-card-table-cell">
                            <span class="plp-card-table-label">${label}:</span>
                            <span class="plp-card-table-value">${value}</span>
                          </td>
                        </tr>`;
                    }
                }
             }
        });

        if (!rows) return '';

        return `
        <div class="plp-card-dimensions">
            <table class="plp-card-table">
              <thead>
                <tr>
                  <th class="plp-card-table-title">DIMENSIONS</th>
                </tr>
              </thead>
              <tbody>
                ${rows}
              </tbody>
            </table>
        </div>`;
    }

    function renderMaterialsTable(tags) {
        if (!tags || !Array.isArray(tags)) return '';

        let rows = '';
        tags.forEach(function(tag) {
             if(tag.includes(':') && tag.includes('material')) {
                if(!tag.includes('N/A')) {
                    const parts = tag.split(':');
                    const label = parts[0].replace(/_/g, ' ');
                    const value = parts[1];

                    rows += `
                    <tr class="plp-card-table-row">
                      <td class="plp-card-table-cell">
                        <span class="plp-card-table-label">${label}:</span>
                        <span class="plp-card-table-value">${value}</span>
                      </td>
                    </tr>`;
                }
             }
        });

        if (!rows) return '';

        return `
        <div class="plp-card-materials">
            <table class="plp-card-table">
              <thead>
                <tr>
                  <th class="plp-card-table-title">MATERIALS</th>
                </tr>
              </thead>
              <tbody>
                ${rows}
              </tbody>
            </table>
         </div>`;
    }

    function renderPromoImage(config, productUrl) {
        if (!config || !config.promo_image || config.promo_image === 'null') return '';

        const link = config.promo_link_url || productUrl;

        // Handle pre-resolved URL or file handle
        let imgUrl = config.promo_image;
        if(imgUrl.includes && !imgUrl.includes('/')) {
             imgUrl = 'https://cdn.shopify.com/s/files/1/0000/0000/files/' + imgUrl;
        }

        // Append size params for Shopify CDN
        if (imgUrl.includes('?')) {
          imgUrl += '&width=434&height=327';
        } else {
          imgUrl += '?width=434&height=327';
        }

        return `
          <a href="${link}" class="plp-card-promo-link" target="_blank">
            <img
              src="${imgUrl}"
              alt=""
              class="plp-card-promo-icon"
              width="110"
              height="85"
              loading="lazy"
            >
          </a>`;
    }

    function render(product, config) {
        config = config || {};
        const sectionId = config.section_id || 'template';
        const productFormId = 'quick-add-' + sectionId + '-' + product.id;

        let imageHtml = `
            <div class="plp-card-no-image">
               <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-no-photo" viewBox="0 0 20 20"><path fill="#444" d="M10 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 2a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm-8 7V5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm14-12a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v12h12V5z"/></svg>
            </div>`;

        if (product.featured_media && product.featured_media.url) {
            imageHtml = `
            <img
              src="${product.featured_media.url}"
              alt="${product.featured_media.alt || product.title}"
              class="plp-card-image"
              loading="lazy"
              width="${product.featured_media.width || 800}"
              height="${product.featured_media.height || 800}"
            >`;
        }

        let descHtml = '';
        if (product.description) {
            const cleanDesc = product.description.replace(/<[^>]*>?/gm, '');
            descHtml = `<p class="plp-card-description">${cleanDesc}</p>`;
        }

        const variantId = product.selected_or_first_available_variant ? product.selected_or_first_available_variant.id : (product.variants && product.variants.length ? product.variants[0].id : '');
        const isAvailable = product.available;

        // This structure mirrors the user's provided 'card-product-plp.liquid' snippet
        return `
        <article class="plp-product-card" data-product-item-content>
            <div class="plp-card-inner">
              <div class="plp-card-media">
                <a href="${product.url}">
                  ${imageHtml}
                </a>
              </div>
              <div class="plp-card-content-overall">
                <div class="plp-card-content">
                  <div class="plp-card-content-left">
                    <h3 class="plp-card-title">
                      <a href="${product.url}" class="plp-card-title-link">
                        ${product.title}
                      </a>
                    </h3>
                    ${descHtml}
                    <a href="${product.url}" class="plp-card-view-details">
                      View full details
                    </a>
                  </div>
                  <div class="plp-card-content-right">
                    ${renderPromoImage(config, product.url)}
                    <div class="plp-right-w">
                      <div class="plp-card-price">
                        ${renderPrice(product)}
                      </div>
                      <product-form class="plp-card-form-container" data-section-id="${sectionId}">
                        <form method="post" action="/cart/add" id="${productFormId}" accept-charset="UTF-8" class="plp-card-form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                          <input type="hidden" name="form_type" value="product">
                          <input type="hidden" name="utf8" value="✓">
                          <input
                            type="hidden"
                            name="id"
                            value="${variantId}"
                            class="plp-card-variant-id"
                            ${ !isAvailable ? 'disabled' : '' }
                          >
                          <button
                            type="submit"
                            name="add"
                            class="plp-card-add-button"
                            ${ !isAvailable ? 'disabled' : '' }
                          >
                            <span>Add to order</span>
                            <div class="loading-overlay__spinner hidden">
                               <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                                 <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                               </svg>
                            </div>
                          </button>
                        </form>
                      </product-form>
                    </div>
                  </div>
                </div>
                <div class="plp-card-tables">
                  ${renderDimensionsTable(product.tags)}
                  ${renderMaterialsTable(product.tags)}
                </div>
              </div>
            </div>
        </article>
        `;
    }

    return {
        render: render
    };

})();

// Expose to window
window.ProductRenderer = ProductRenderer;
